import { Injectable } from '@angular/core';
import { IntensityDto } from '../../beneficiaries/dto/intensity.dto';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class IntensityService {
  constructor(private readonly api: ApiService) {}

  public async findAll(): Promise<IntensityDto[]> {
    const url: string = environment.api.intensity;
    return this.api.get<IntensityDto[]>(url);
  }
}
